/* jshint esnext: true */
// global mazeSettings, $

// @codekit-prepend "lib/properties.js";
// @codekit-prepend "lib/map.js";
// @codekit-prepend "lib/helpers.js";
// @codekit-prepend "lib/rando.js";
// @codekit-prepend "lib/settings.js";

// @codekit-prepend "game/controls.js";
// @codekit-prepend "game/controls-swipe.js";

// @codekit-prepend "game/game-character.js";
// @codekit-prepend "game/game-data.js";
// @codekit-prepend "game/game-timer.js";
// @codekit-prepend "game/gameplay.js";

// @codekit-prepend "game/modals.js";
// @codekit-prepend "game/modals-controller.js";

// @codekit-prepend "game/states.js";
// @codekit-prepend "game/state-buttons.js";
// @codekit-prepend "game/state-controller.js";

// @codekit-prepend "game/addons.js";
// @codekit-prepend "game/store.js";
// @codekit-prepend "game/moves.js";
// @codekit-prepend "game/mazes.js";

// @codekit-prepend "game/scene-controller.js";
// @codekit-prepend "game/scene-load.js";
// @codekit-prepend "game/scene-menu.js";
// @codekit-prepend "game/scene-game.js";

const sceneProperties = [
	SceneLoad,
	SceneController,
	SceneMenu,
	SceneGame
];

let game_size = get_game_size();

const config = {
	parent: 'game-play',
	title: 'MazeMazeMaze',
	url: 'https://mazemazemaze.com',
	type: Phaser.AUTO,
	backgroundColor: 0x000,
	scale: {
		parent: 'game-play',
		mode: Phaser.Scale.NO_SCALE,
		width: game_size.width,
		height: game_size.height,
	},
	scene: sceneProperties,
	pixelArt: true,
	roundPixels: true,
	input: {
		windowEvents: false
	}
};

const game = new Phaser.Game( config );

const gameInit = () => {

	states.init();
	stateButtons.init();
	store.init();
	modals.init();

};

$( window ).on(
	'resize',
	resize_game
);

// $( 'button.rando' ).on(
// 	'click',
// 	function() {

// 		gameplay.newLevel();
// 		console.log( 'button rando' );

// 	}
// );

